import React from 'react'
import { initializeApollo } from '@gql/client'
import { PaginaDocument, RivenditoriDocument, CittaDocument, ProvinciaDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import { RivenditoriTemplate } from '@components/templates'

const RivenditoriPage = ({ pagina, rivenditori, citta, localita }) => (
  <RivenditoriTemplate
    pagina={pagina}
    rivenditori={rivenditori}
    items={citta}
    localita={localita}
    variant={'provincia'}
  />
)

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []

  return {
    paths: paths,
    fallback: 'blocking',
  }
}, '/rivenditori/[slug_regione]/[slug_provincia]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug_regione, slug_provincia }, locale, preview, previewData }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'rivenditori', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const {
      data: { rivenditori },
    } = await client.query({
      query: RivenditoriDocument,
      variables: {
        provincia: slug_provincia,
      },
    })

    if (!rivenditori || rivenditori.length == 0) {
      return {
        notFound: true,
      }
    }

    const {
      data: { citta },
    } = await client.query({
      query: CittaDocument,
      variables: {
        provincia: slug_provincia,
      },
    })

    const {
      data: { provincia: localita },
    } = await client.query({
      query: ProvinciaDocument,
      variables: {
        slug: slug_provincia,
      },
    })

    return {
      props: { pagina, rivenditori, citta, localita },
      revalidate: 60 * 20,
    }
  },
  '/rivenditori/[slug_regione]/[slug_provincia]'
)

export default RivenditoriPage
